<template>
    <tr>
        <td class="bigger-padding">
            <div class="font-normal top">{{ item.name | maxLength}}</div>
            <div class="font-small bottom">{{ item.also }}</div>
        </td>
        <td class="right bigger-padding">
            <div class="font-normal top">CHF {{ item.price }}</div>
            <div class="font-small green" v-if="item.plus >= 0">
                + CHF {{ item.plus }}
            </div>
            <div class="font-small red" v-else>- CHF {{ item.plus }}</div>
        </td>
        <td class="bigger-padding">
            <div class="img-next">
                <img src="../../assets/images/next.svg" alt="">
            </div>
        </td>
    </tr>
</template>

<script>
  export default {
    props: ['item']
  }
</script>

<style lang="scss" scoped>
    @import '../../styles/app.scss';
</style>
